export class AuthorizeAction {
  public action = '';
  public type = '';
}
